import { User } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

const SIZE = {
  sm: 'size-8 text-type-label',
  md: 'size-10 text-type-label',
  lg: 'size-14 text-type-body',
};

/**
 * Avatar (ds/avatar) — iniciais, imagem ou placeholder.
 */
export function Avatar({
  size = 'md',
  initials,
  src,
  alt = '',
  status,
  className,
}) {
  const sizeClass = SIZE[size] || SIZE.md;
  const hasImage = Boolean(src);
  const hasInitials = Boolean(initials);

  return (
    <span
      data-ds-id={
        status
          ? 'ds/avatar--status-online'
          : hasImage
            ? 'ds/avatar--image'
            : hasInitials
              ? 'ds/avatar--initials'
              : 'ds/avatar--placeholder'
      }
      className={cn(
        'relative inline-grid shrink-0 place-items-center overflow-hidden rounded-ds-full bg-sage-100 font-semibold text-sage-700 ring-1 ring-sage-border dark:bg-sage-900/50 dark:text-sage-300',
        !hasImage && !hasInitials && 'bg-muted text-muted-foreground ring-border',
        sizeClass,
        className,
      )}
    >
      {hasImage ? (
        <img src={src} alt={alt} className="size-full object-cover" />
      ) : hasInitials ? (
        <span aria-hidden={false}>{String(initials).slice(0, 2).toUpperCase()}</span>
      ) : (
        <User className="size-[55%]" aria-hidden />
      )}
      {status === 'online' ? (
        <span
          className="absolute -bottom-0.5 -right-0.5 size-3.5 rounded-ds-full bg-success-500 ring-2 ring-background"
          aria-hidden
        />
      ) : null}
    </span>
  );
}

export default Avatar;
